import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import remark from 'remark';
import strip from 'strip-markdown';
import config from '../siteConfig';
import PostHeader from '../components/PostHeader';
import PostFooter from '../components/PostFooter';
import AuthorBio from '../components/AuthorBio';
import Pagination from '../components/Pagination';
import Seo from '../components/Seo';

export default function BlogPostTemplate({ data, pathContext }) {
  const { site, post } = data;
  const { previousPost, nextPost } = pathContext;
  const title = `${site.meta.title} - ${post.frontmatter.title}`;

  const postSeo = {
    type: 'CreativeWork',
    title: post.frontmatter.title,
    description: remark()
      .use(strip)
      .processSync(post.excerpt)
      .toString(),
    author: post.frontmatter.author,
    datePublished: post.frontmatter.datePublishedRaw,
    dateModified: post.frontmatter.dateModifiedRaw,
  };

  return (
    <div className="site-page">
      <Seo pageSeo={postSeo} />
      <article className="blog-post">
        <Helmet title={title} />

        <PostHeader frontMatter={post.frontmatter} />

        <div className="blog-post--content" dangerouslySetInnerHTML={{ __html: post.html }} />

        <PostFooter frontMatter={post.frontmatter} />
      </article>
      <AuthorBio />
      <Pagination
        baseRoute={config.routePosts}
        isFirstPage={!previousPost}
        isLastPage={!nextPost}
        previousRoute={previousPost ? previousPost.frontmatter.slug : ''}
        nextRoute={nextPost ? nextPost.frontmatter.slug : ''}
        previousText="Previous Post"
        nextText="Next Post"
      />
    </div>
  );
}

BlogPostTemplate.propTypes = {
  data: PropTypes.shape({
    site: PropTypes.object.isRequired,
    post: PropTypes.object.isRequired,
  }).isRequired,
  pathContext: PropTypes.shape({
    previousPost: PropTypes.object.isRequired,
    nextPost: PropTypes.object.isRequired,
  }).isRequired,
};

export const query = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      meta: siteMetadata {
        title
        description
        siteUrl
        author
      }
    }
    post: markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      excerpt
      html
      frontmatter {
        slug
        title
        author
        datePublishedRaw: datePublished
        datePublishedFormatted: datePublished(formatString: "MMMM DD, YYYY")
        dateModifiedRaw: dateModified
        dateModifiedFormatted: dateModified(formatString: "MMMM DD, YYYY")
        tags
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/BlogPostTemplate.js